export default "__VITE_ASSET__DVuF$Rc3__"